export default "__VITE_ASSET__D4fy3Nuc__"